var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  fill: "currentColor",
  viewBox: "0 0 24 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M-4-8h32v32H-4z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  style: {
    overflow: "visible"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 16h24v-2.7H0zm0-6.7h24V6.7H0zM0 0v2.7h24V0z",
  style: {
    clipPath: "url(#b)"
  }
}));
export default SvgMenu;